import React from 'react';

const Calendly = () => {
  return (
    <>
      <h5>
        <b>Calendly</b>
      </h5>
      <p>
        Calendly is great for scheduling meetings professionally and efficiently. It allows you to
        eliminate the hassle of back-and-forth emails and saves ample time.
      </p>
      <br />
    </>
  );
};

export default Calendly;
